module.exports = __webpack_public_path__ + "img/cari_de.571eafad.svg";